import React, { Component } from 'react'
import { css } from '@emotion/react'
import isEqual from 'fast-deep-equal'
import SpacedItems from 'shared/components/ui/SpacedItems'

import AgentsChip from './AgentsChip'

const constainerStyle = () => theme => css`
  padding: 0 ${theme.spacing['12']} ${theme.spacing['10']};
  overflow: hidden;
  position: absolute;
  top: -48px;
`

export default class AgentCollision extends Component {
  shouldComponentUpdate(nextProps) {
    return !isEqual(this.props, nextProps)
  }

  render() {
    const {
      viewingAgents,
      replyingAgents,
      notingAgents,
      typingReplyAgents,
      typingNoteAgents,
      className,
    } = this.props
    if (
      viewingAgents.length === 0 &&
      replyingAgents.length === 0 &&
      notingAgents.length === 0 &&
      typingReplyAgents.length === 0 &&
      typingNoteAgents.length === 0
    ) {
      return null
    }
    return (
      <SpacedItems.Container
        direction="horizontal"
        gap="large"
        className={className}
        css={constainerStyle}
      >
        {viewingAgents.length > 0 && (
          <SpacedItems.Item>
            <AgentsChip users={viewingAgents} type="viewing" />
          </SpacedItems.Item>
        )}
        {replyingAgents.length > 0 && (
          <SpacedItems.Item>
            <AgentsChip users={replyingAgents} type="replying" />
          </SpacedItems.Item>
        )}
        {notingAgents.length > 0 && (
          <SpacedItems.Item>
            <AgentsChip users={notingAgents} type="noting" />
          </SpacedItems.Item>
        )}
        {typingReplyAgents.length > 0 && (
          <SpacedItems.Item>
            <AgentsChip users={typingReplyAgents} type="typingReply" />
          </SpacedItems.Item>
        )}
        {typingNoteAgents.length > 0 && (
          <SpacedItems.Item>
            <AgentsChip users={typingNoteAgents} type="typingNote" />
          </SpacedItems.Item>
        )}
      </SpacedItems.Container>
    )
  }
}
